import { render, staticRenderFns } from "./Flame.vue?vue&type=template&id=31c173a1&scoped=true"
var script = {}
import style0 from "./Flame.vue?vue&type=style&index=0&id=31c173a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c173a1",
  null
  
)

export default component.exports